import { FIELDS, TAB_VIEW_SECTIONS, TABS } from '../constants';

export const { ADVANCED, AFFORDABLE, OVERVIEW } = TABS;
export const { CONTACT_INFO, FEATURES, MARKETING_MEDIA, PROPERTY_DETAILS } =
  TAB_VIEW_SECTIONS[OVERVIEW];
export const HOURS = 'hours';
export const { CROSS_SELL, GUEST_CARD_REQUIREMENTS } =
  TAB_VIEW_SECTIONS[ADVANCED];
export const { AFFORDABLE_OVERVIEW, INCOME_ELIGIBILITY } =
  TAB_VIEW_SECTIONS[AFFORDABLE];

export const {
  [CONTACT_INFO]: CONTACT_INFO_FIELDS,
  [FEATURES]: NOTES_FEATURES_FIELDS,
  [MARKETING_MEDIA]: MARKETING_MEDIA_FIELDS,
  [PROPERTY_DETAILS]: PROPERTY_DETAILS_FIELDS,
} = FIELDS[OVERVIEW];

export const {
  [CROSS_SELL]: CROSS_SELL_FIELDS,
  [GUEST_CARD_REQUIREMENTS]: GUEST_CARD_REQUIREMENTS_FIELDS,
} = FIELDS[ADVANCED];

export const {
  [AFFORDABLE_OVERVIEW]: AFFORDABLE_OVERVIEW_FIELDS,
  [INCOME_ELIGIBILITY]: INCOME_ELIGIBILITY_FIELDS,
} = FIELDS[AFFORDABLE];
